// extracted by mini-css-extract-plugin
module.exports = {"card":"CardDog_card__M8Vkq","titleName":"CardDog_titleName__2qmiM","imgcard":"CardDog_imgcard__1DEzE"};